"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var NewsletterBanner = function (additionalFormData) {
    var imageName = 'newsletter';
    var iconName = 'newsletter-checked';
    return (React.createElement("div", { className: "grid grid-cols-12 newsletter-promo" },
        React.createElement("div", { className: "col-span-12 sm:col-span-9 newsletter-bullets" },
            React.createElement("div", { className: "newsletter-bullet mb-[10px]" },
                React.createElement("span", { className: "inline-block" },
                    React.createElement("img", { className: "mr-[10px]", src: "/static/images/".concat(iconName, ".svg"), alt: iconName })),
                React.createElement("span", null, additionalFormData.popUpBulletTop)),
            React.createElement("div", { className: "newsletter-bullet mb-[10px]" },
                React.createElement("span", { className: "inline-block" },
                    React.createElement("img", { className: "mr-[10px]", src: "/static/images/".concat(iconName, ".svg"), alt: iconName })),
                React.createElement("span", null, additionalFormData.popUpBulletMiddle)),
            React.createElement("div", { className: "newsletter-bullet mb-[10px]" },
                React.createElement("span", { className: "inline-block" },
                    React.createElement("img", { className: "mr-[10px]", src: "/static/images/".concat(iconName, ".svg"), alt: iconName })),
                React.createElement("span", null, additionalFormData.popUpBulletBottom))),
        React.createElement("div", { className: "sm:col-span-3 newsletter-bullets-image" },
            React.createElement("img", { src: "/static/images/".concat(imageName, ".svg"), alt: imageName }))));
};
exports.default = NewsletterBanner;
